import { updates } from '@/mocks/homeMocks';

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-10 md:py-14 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="flex items-center justify-between mb-6">
            <div>
              <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-1 scroll-mt-20">
                更新动态
              </h2>
              <p className="text-sm text-foreground-600">最新漫画更新和平台动态速递</p>
            </div>
            <a
              href="#updates"
              className="hidden sm:flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              查看全部 <i className="ri-arrow-right-line"></i>
            </a>
          </div>
          <div className="space-y-0">
            {updates.map((item, idx) => (
              <a
                key={item.id}
                href="#updates"
                className={`flex items-start gap-3 md:gap-4 py-3 md:py-4 cursor-pointer hover:bg-background-100 rounded-md px-2 transition-colors ${
                  idx < updates.length - 1 ? 'border-b border-background-200/70' : ''
                }`}
              >
                <span className="text-xs text-foreground-500 whitespace-nowrap mt-0.5 w-12 shrink-0">
                  {item.date}
                </span>
                <div className="flex-1 min-w-0">
                  <h3 className="text-sm md:text-base text-foreground-950 truncate">
                    {item.title}
                  </h3>
                  <p className="text-xs md:text-sm text-foreground-600 mt-0.5 truncate">
                    {item.summary}
                  </p>
                </div>
                <span className="px-2 py-0.5 bg-secondary-100 text-secondary-800 text-xs rounded whitespace-nowrap shrink-0">
                  {item.category}
                </span>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}